import { cn } from '@wwe-portal/ui/lib/lib';
import { FC, ReactNode } from 'react';

interface RosterCardLayoutProps {
  image: ReactNode;
  flipButton?: ReactNode;
  className?: string;
}

export const RosterCardLayout: FC<RosterCardLayoutProps> = ({
  flipButton,
  image,
  className,
}) => {
  return (
    <div
      className={cn(
        'rounded-10 relative flex w-full flex-col items-center italic',
        className
      )}
    >
      <div className="mb-10 mt-4 w-full flex-grow px-3">
        <div className="h-full w-full">{image}</div>
      </div>
      <div className="absolute bottom-0 translate-y-1/2">{flipButton}</div>
    </div>
  );
};
